export default __webpack_public_path__ + "6220849dd275b423f829f1c537cb9416.png";